/**
 * æ¾ç¤ºéèè§åæ¨¡å
 */
export interface ShowHiddenRuleModel {
  /**
   * æ¡ä»¶æ»¡è¶³ç±»å
   */
  showHiddenSatisfyType: ShowHiddenSatisfyType;

  /**
   * æ¾ç¤ºéèè§å
   */
  showHiddenRuleType: ShowHiddenRuleType;

  /**
   * ç®æ æ§ä»¶åç§°
   *
   */
  targetControlsName: string[];

  /**
   * æ¾éæ¡ä»¶
   */
  conditions: ShowHiddenCondition[];
}

/**
 * æ¾ç¤ºéèæ¡ä»¶
 */
export interface ShowHiddenCondition {
  controlName: string;
  op: string;
  value: string;
}

/**
 * æ¾ç¤ºéèæ»¡è¶³ç±»å
 *
 */
export enum ShowHiddenSatisfyType {
  All,
  Any
}

export const showHiddenSatisfyTypes = [
  {
    value: ShowHiddenSatisfyType.All,
    text: 'ææ'
  },
  { value: ShowHiddenSatisfyType.Any, text: 'ä»»ä¸' }
];

export const showHiddenSatisfyShowTypes = [
  {
    value: ShowHiddenSatisfyType.All,
    text: 'ä¸'
  },
  { value: ShowHiddenSatisfyType.Any, text: 'æ' }
];

/**
 * æ¾ç¤ºéèè§åç±»å
 */
export enum ShowHiddenRuleType {
  Show,
  Hidden
}

export const showHiddenRuleTypes = [
  {
    value: ShowHiddenRuleType.Show,
    text: 'æ¾ç¤º'
  },
  { value: ShowHiddenRuleType.Hidden, text: 'éè' }
];

/**
 * æ¾éè§åæä½ç¬¦
 */
export const showHiddenOperator = {
  Equal: 'equal',
  NotEqual: 'notEqual',
  Null: 'null',
  NotNull: 'notNull'
};

export const showHiddenOperators = [
  { value: showHiddenOperator.Equal, text: 'ç­äº' },
  { value: showHiddenOperator.NotEqual, text: 'ä¸ç­äº' },
  { value: showHiddenOperator.Null, text: 'ä¸ºç©º' },
  { value: showHiddenOperator.NotNull, text: 'ä¸ä¸ºç©º' }
];
